import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/contabilidade/transparencia/contrato/'

class EmpenhosContratoService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
    }

    consultar(filtro) {
        let data = {
            sequencia: filtro.sequencia,
        }

        return this.conex.post(urlContrato + 'detalhesEmpenho/', JSON.stringify(data))
    }

    consultarPorLicitacao(filtro) {
        let data = {
            numeroTotal: filtro.numeroTotal,
        }

        return this.conex.post(urlContrato + 'empenhosLicitacao/', JSON.stringify(data))
    }
}

export default EmpenhosContratoService
